import { Expose, plainToClass, Transform, Type } from 'class-transformer';
import { ApplicationName } from '../../common';
import { BasicUser } from './basic-user-model';
import { DropdownModel } from './dropdown-model';
import { Category } from './category-model';

export class BaseStudent extends DropdownModel {
  @Expose()
  @Transform(({ obj }) => plainToClass(BasicUser, obj, { strategy: 'excludeAll' }))
  user: BasicUser;

  @Expose() emailValid: boolean;
  @Expose() enableVideoRecording: boolean;
  @Expose() enableVoiceRecording: boolean;
  @Expose() isChildDependent: boolean;
  @Expose() parent: string;
  @Expose() isCallsBlocked: boolean;
  @Expose() isLoginBlocked: boolean;
  @Expose() appName: ApplicationName;
  @Expose() type: string;
  @Expose() isPayPackagesBlocked: boolean;
  @Expose() isReserveBlocked: boolean;
  @Expose() isNewMuslim?: boolean;
  @Expose({ name: 'categorize' })
  @Type(() => Category)
  category: Category[];
  @Expose() isAdminSetTempPassword: boolean;

  /**
   * @TODO check integration of this fields
   */
  @Expose() educationalLevel: string;
  @Expose() maritalStatus: string;
  @Expose() employmentStatus: string;
  @Expose() age: number;
  @Expose()
  @Transform(({ value }) => value ?? 0)
  walletBalance: number;

  override get dropDownDisplayName(): string {
    return this.user.fullName;
  }
  override get dropDownValue(): Object {
    return this;
  }
}
